import React from "react"

import T from "prop-types"

export const Downloader = ({ url }) => {
  return url && url !== "" ? <iframe style={{ display: "none" }} src={url} /> : null
}

Downloader.propTypes = {
  url: T.oneOfType([T.string, T.bool]),
}
